import ReactPlayer from "react-player";
import type { Ref } from "react";
import React from "react";
import styled from "styled-components";
import { createMessage, ENTER_VIDEO_URL } from "@appsmith/constants/messages";
import WebRtcStreamer from "./WebRtcStreamer";
export interface VideoComponentProps {
  url?: string;
  autoPlay?: boolean;
  isWidth?: boolean;
  isHeight?: boolean;
  playing?: boolean;
  controls?: boolean;
  onStart?: () => void;
  onPlay?: () => void;
  onPause?: () => void;
  onEnded?: () => void;
  onReady?: () => void;
  onProgress?: () => void;
  onSeek?: () => void;
  onError?: () => void;
  player?: Ref<ReactPlayer>;
  backgroundColor?: string;
  borderRadius?: string;
  boxShadow?: string;
  urlData: any;
  columns: number;
  itemSpacing: number;
}

const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const VideoWrapper = styled.div<{
  borderRadius?: string;
  boxShadow?: string;
  backgroundColor?: string;
  fr: number;
  itemSpacing: number;
}>`
  height: 100%;
  display: grid;
  grid-template-columns: repeat(${(props) => props.fr}, 1fr);
  grid-template-rows: repeat(${(props) => props.fr}, 1fr);
  gap: ${(props) => props.itemSpacing}px;
  & video,
  & > div {
    background: ${({ backgroundColor }) => backgroundColor};
    border-radius: ${({ borderRadius }) => borderRadius};
    box-shadow: ${({ boxShadow }) => boxShadow} !important;
    overflow: hidden;
  }
`;

const Error = styled.span``;
const rows:Record<string, number> = {
  1: 1,
  4: 2,
  9: 3,
  16: 4
}
export default function VideoComponent(props: VideoComponentProps) {
  const {
    autoPlay,
    controls,
    onEnded,
    onError,
    onPause,
    onPlay,
    onProgress,
    onReady,
    onSeek,
    onStart,
    player,
    playing,
    urlData,
    columns,
    itemSpacing,
    isWidth,
    isHeight
  } = props;

  return (
    <VideoWrapper
      backgroundColor={props.backgroundColor}
      borderRadius={props.borderRadius}
      boxShadow={props.boxShadow}
      fr={rows[columns] || 1}
      itemSpacing={itemSpacing}
    >
      {
        Array(columns).fill(columns).map((i:any, idx:number)=>{
          let url = urlData[idx]?.url;
          if(!url){
            return <div className='video-grid-item' style={{backgroundColor: `rgba(0,0,0,${0.6-(idx/columns)*0.5})`}} />
          }else if(url.startsWith('rtsp://')){
            return <WebRtcStreamer isWidth={isWidth} isHeight={isHeight} url={url} />
          }else{
            return (
              <ReactPlayer
                controls={false}
                height="100%"
                muted={autoPlay}
                onEnded={onEnded}
                onError={onError}
                onPause={onPause}
                onPlay={onPlay}
                onProgress={onProgress}
                onReady={onReady}
                onSeek={onSeek}
                onStart={onStart}
                pip={false}
                playing={playing}
                ref={player}
                url={url}
                width="100%"
              />
            )
          }
        })
      }
    </VideoWrapper>
  );
}
